<script>
    import user from "../stores/user";
    import Warning from "../components/pages/Warning.svelte";
    import OrderData from "./OrderData.svelte";

    export let hash;
</script>

<div class="container">
    {#if $user.token}
        <div class="mb-5">
            <h1>Στοιχεία παραγγελίας</h1>
            <div class="heading-separator"></div>
        </div>
        <OrderData {hash} page="order-details"/>
    {:else}
        <Warning warning="no-user" page="order-details" header="Σύνδεση στον λογαριασμό σας"/>
    {/if}
</div>